var React = require('react');

function ShapeleafblueInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,212V161A161,161,0,0,1,161,0H270V50.92A161,161,0,0,1,109,212Z","fill":"#0076ae","opacity":"0.15","style":{"isolation":"isolate"}}));
}

ShapeleafblueInline.defaultProps = {"id":"Calque_1","data-name":"Calque 1","viewBox":"0 0 270 211.95"};

module.exports = ShapeleafblueInline;

ShapeleafblueInline.default = ShapeleafblueInline;
